import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import './CollegeMetaInfoList.css';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import BackArrow from '../../public/icons/mycoach-backarrow.svg';
import NOCourses from '../../public/icons/no_courses.jpg';
import ForwardArrow from '../../public/icons/right-chevron.png';
import ProgramDetails from '../university-courses/ProgramDetails';
import axios from 'axios';
import common from '../../common';
import categoryImage from '../../public/icons/category.jpg';
import UniBlogList from '../university-courses/UniBlogList';



const CollegeMetaInfoList = (props) => {
    const { getCollegeDetails, university, wpUniversityCategory, wpUniversityPosts,
        wpCourseCategory, wpTestimonialsCategory
    } = props;
    const [collegeInfo, setCollegeInfo] = useState(null);
    const [postCategory, setPostCategory] = useState(null);

    const location = useLocation();
    const [enrollment, setEnrollment] = useState(null);
    const userId = localStorage.getItem("user_id");
    const [showAll, setShowAll] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [selectedContent, setSelectedContent] = useState('Overview');
    const [universityPosts, setuniversityPosts] = useState(null);
    const [courseCategory, setCourseCategory] = useState(null);
    const [testimonialsCategory, setTestimonialsCategory] = useState(null);
    const [cateogryId, setCateogryId] = useState(null)
    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(null)

    const testImages = [
        'https://acado.edulystventures.com/wp-content/uploads/2024/11/Ungame.png',
        'https://acado.edulystventures.com/wp-content/uploads/2024/11/Real-life.png'
    ]



    useEffect(() => {
        const fetchCollegeInfo = async () => {
            try {
                const collegeInfoResp = await getCollegeDetails(3);
                if (collegeInfoResp?.data) {
                    setCollegeInfo(collegeInfoResp.data);

                } else {
                    setCollegeInfo(null);
                }
            } catch (error) {
                console.error("Error fetching college info:", error);
                setCollegeInfo(null);
            }
        };

        getPostCategory();
    }, [getCollegeDetails, university]);


    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    const programsToDisplay = showAll ? university.programs : university.programs.slice(0, 3);

    const handleBrochureDownload = (brochureUrl) => {
        const link = document.createElement('a');
        link.href = brochureUrl;
        link.download = 'brochure.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const selectedCategoryId = (postCategory) => {
        console.log('postCategory:', postCategory);
        console.log('university name:', university?.name);
        const categoryIds = postCategory?.filter(val => val?.name?.toLowerCase() == university?.name?.toLowerCase());
        if (Array.isArray(categoryIds) && categoryIds.length > 0) {
            return categoryIds[0].id;


        }
        return null;
    }
    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    useEffect(() => {

        if (selectedContent === 'Blogs') {
            getUniversityPosts();
        }
    }, [selectedContent]);


    useEffect(() => {
        if (selectedContent === `Placement` ||  selectedContent ===   'Faculty') {
            getCourseCategory();

        }
    }, [selectedContent]);

    useEffect(() => {
        if (!postCategory) {
            getPostCategory();
        }
    }, [postCategory]);


    useEffect(() => {
        if (selectedContent === `Testimonials`) {
            getTestimonialsCategory();
        }
    }, [selectedContent]);





    const getUniversityPosts = async () => {
        try {
            const categoryId = selectedCategoryId(postCategory);
            console.log('Fetching university posts...');
            const universityPostsResp = await wpUniversityPosts(selectedCategoryId(categoryId));
            if (Array.isArray(universityPostsResp)) {
                console.log('Received data:', universityPostsResp);
                setuniversityPosts(universityPostsResp);
            } else if (universityPostsResp?.data) {
                console.log('Received data:', universityPostsResp.data);
                setuniversityPosts(universityPostsResp.data);
            } else {
                console.warn('No data found in response');
                setuniversityPosts(null);
            }
        } catch (error) {
            console.error('Error fetching university posts:', error);
            setuniversityPosts(null);
        }
    };

    const getCourseCategory = async () => {
        try {
            setLoading(true);
            setError(null);

            console.log('Fetching university posts...');
            const courseCategoryResp = await wpCourseCategory(827);

            if (courseCategoryResp && typeof courseCategoryResp === 'object') {
                console.log('Received data:', courseCategoryResp);
                setCourseCategory(courseCategoryResp);

            } else {
                console.warn('No data found in response');
                setCourseCategory(null);
            }
        } catch (error) {
            console.error('Error fetching university posts:', error);
            setError('Failed to fetch course category data.');
        } finally {
            setLoading(false);
        }
    };


    const getTestimonialsCategory = async () => {
        try {
            setLoading(true);
            setError(null);

            console.log('Fetching university posts...');
            const testimonialsCategoryResp = await wpTestimonialsCategory(827);
            if (Array.isArray(testimonialsCategoryResp)) {
                console.log('Received data:', testimonialsCategoryResp);
                setTestimonialsCategory(testimonialsCategoryResp);
            } else if (testimonialsCategoryResp?.data) {
                console.log('Received data:', testimonialsCategoryResp.data);
                setTestimonialsCategory(testimonialsCategoryResp.data);
            } else {
                console.warn('No data found in response');
                setTestimonialsCategory(null);
            }
        } catch (error) {
            console.error('Error fetching university posts:', error);
            setError('Failed to fetch course category data.');
        } finally {
            setLoading(false);
        }
    };





    const getPostCategory = async () => {
        try {
            console.log('Fetching university posts...');
            const PostCategoryResp = await wpUniversityCategory();
            if (Array.isArray(PostCategoryResp)) {
                console.log('Received data:', PostCategoryResp);
                setPostCategory(PostCategoryResp);
            } else if (PostCategoryResp?.data) {
                console.log('Received data:', PostCategoryResp.data);
                setPostCategory(PostCategoryResp.data);
            } else {
                console.warn('No data found in response');
                setPostCategory(null);
            }
        } catch (error) {
            console.error('Error fetching university posts:', error);
            setPostCategory(null);
        }

    };

    const renderContent = () => {
        switch (selectedContent) {
            case 'Overview':
                return (
                    <div className="overview_container">
                        <p>
                            We are a multi-disciplinary and an international higher education institute in Satakunta region, west coast of Finland. <br /> In our operating area, we are a significant creator of experts as well as a developer, a propeller of internationalisation <br /> and a promoter of entrepreneurship.  </p>

                        <img
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80" alt="" />

                        <h2>{university?.name}</h2>
                        <p>{university?.description}</p>

                    </div>
                );

            case 'Courses':
                return (
                    <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', paddingTop: '20px', border: '2px solid  rgba(179, 177, 177, 0.391)', }}>
                        {programsToDisplay.length > 0 ? (
                            programsToDisplay?.map((program, index) => (
                                <div key={index} style={{ border: '2px solid black', padding: '16px', backgroundColor: '#f9f9f9' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', padding: '16px', backgroundColor: '#f0f0f0' }}>
                                        <img
                                            src={program.image || NOCourses}
                                            alt={program.label}
                                            width={80}
                                            height={80}
                                            style={{ borderRadius: '8px', objectFit: 'cover' }}
                                        />
                                        <h3 style={{
                                            marginLeft: '16px',
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 2,
                                            lineHeight: '1.2em',
                                            maxHeight: '2.4em'
                                        }}>{program.label}</h3>
                                    </div>
                                    <div style={{ padding: '16px', }}>
                                        <p style={{ fontSize: '14px', color: '#6B7280' }}>{program.description || ""}</p>

                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                            {Array.isArray(program.skills) && program.skills.length > 0 ? (
                                                program.skills.map((skill, skillIndex) => (

                                                    <span
                                                        key={skillIndex}
                                                        style={{
                                                            padding: '4px 8px',
                                                            fontSize: '12px',
                                                            fontWeight: '500',
                                                            backgroundColor: '#E0E7FF',
                                                            color: '#3B82F6',
                                                            borderRadius: '12px',
                                                        }}

                                                    >
                                                        {skill}


                                                    </span>


                                                ))

                                            ) : (
                                                <span style={{ fontSize: '14px', color: '#6B7280' }}></span>
                                            )}


                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <span
                                                // onClick={() => courseEnrollment(userId, program.id)}
                                                onClick={() => setSelectedProgram(program)}
                                                style={{
                                                    backgroundColor: "#000000",
                                                    color: "#ffffff",
                                                    padding: "10px 20px",
                                                    fontSize: "12px",
                                                    border: "none",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                    transition: "background-color 0.3s ease",
                                                }}
                                            >
                                                <span>View course details</span>
                                                <img
                                                    src={ForwardArrow}
                                                    alt="View All Icon"
                                                    style={{
                                                        width: "20px",
                                                        height: "20px",
                                                        objectFit: "contain",
                                                        paddingTop: '10px',
                                                        gap: '20px'
                                                    }}
                                                />
                                            </span>
                                        </div>

                                    </div>

                                </div>

                            ))
                        ) : (
                            <p style={{ textAlign: 'center', color: '#6B7280' }}>No courses available.</p>
                        )}

                    </div>

                );

            case 'Admission':
                return (
                    <div className="admitionbox">
                        <p className="text-lg leading-relaxed text-muted-foreground">
                            We welcome applications from students globally who are eager to learn, innovate, and contribute to a vibrant university community. Our admissions process is designed to identify individuals who demonstrate academic potential, a passion for learning, and a desire to make a positive impact in their chosen fields.<b> We consider applications holistically, taking into account academic achievements, personal statements, and, in some cases, interviews or portfolios that showcase the applicant’s unique strengths </b>.     </p>

                        <p> Prospective students can apply to a range of undergraduate, graduate, and doctoral programs, each offering specialized courses and opportunities for hands-on learning. International students are encouraged to apply and will find a supportive community and resources to help them transition to university life in Finland. Additionally, our admissions team provides guidance on scholarships, financial aid, and other support services to help make higher education accessible for all.</p>

                        <p>Our university also values lifelong learning and offers continuing education programs for professionals seeking to advance their skills or explore new career paths. Whether you are a recent high school graduate, a working professional, or an international student, our admissions team is here to support you through every step of the application process.</p>

                        <p>To learn more about specific admission requirements, deadlines, and the application process, we encourage prospective students to visit our website or contact our admissions office. Joining our university means becoming part of a community that values growth, innovation, and academic excellence, where you will be empowered to make a meaningful impact on the world.</p>
                    </div>
                );
            case 'Blogs':
                return (


                    <div className="blogscontainer">
                        <UniBlogList id={selectedCategoryId(postCategory)} />
                    </div>


                );

            case `Why ${university?.name}`:
                return (
                  
                    <div>
                        <div className="about-card">
                            <div className="about-content">
                                <h2>Industry-Aligned Programs and Practical Learning</h2>
                                <p>{university?.name} emphasizes hands-on, practical education tailored to industry needs.</p>
                            </div>
                        </div>

                        <div className="about-card">
                            <div className="about-content">
                                <h2>Cutting-Edge Facilities and Modern Campuses</h2>
                                <p>{university?.name} offers state-of-the-art facilities, including well-equipped labs, collaborative workspaces, and access to modern technology.</p>
                            </div>
                        </div>

                        <div className="about-card">
                            <div className="about-content">
                                <h2>High-Quality Education with an Affordable Tuition Fee</h2>
                                <p>{university?.name} fees are competitive for international students, and the Finnish government supports educational institutions to ensure quality education standards.</p>
                            </div>
                        </div>
                    </div>

                );
            case `Faculty`:
                return courseCategory ? (
                    <div>
                    <div>
                      {courseCategory.faculty_tab.length > 0 ? (
                        courseCategory.faculty_tab.map((faculty, index) => (
                          <div key={index} className="faculty-cardd">
                            <img
                              src={faculty.faculty_thumb}
                              alt={faculty.faculty_title}
                              className="faculty-avatar"
                            />
                            <div className="faculty-info">
                              <h3>{faculty.faculty_title}</h3>
                              <p>{faculty.faculty_designation}</p>
                              <p>{faculty.faculty_description}</p>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No data available.</p>
                      )}
                    </div>
                  </div>
                  
                ) : (
                    <p>No data available.</p>
                );
            case `Testimonials`:
                return (
                    <>

                        {testimonialsCategory && testimonialsCategory?.length > 0 ? (
                            <div className="faculty-card" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                                {testimonialsCategory.map((testimonials, index) => (
                                    <a
                                        href={testimonials.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit', flex: '1 1 calc(50% - 20px)', maxWidth: 'calc(50% - 20px)' }}
                                        key={index}
                                    >
                                        <div>
                                            <img
                                                src={testImages[index % testImages.length]}
                                                key={index}
                                                alt={testimonials.title.rendered}
                                                style={{ width: '200px', height: '200px', borderRadius: '8px', objectFit: 'cover' }}
                                            />
                                            <div style={{ padding: '10px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                                                <h3 className="news-title" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    {testimonials.title.rendered}
                                                </h3>
                                                <p className="news-description" style={{ fontSize: '14px', color: '#555' }}>
                                                    {testimonials.description}
                                                </p>
                                            </div>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        ) : (
                            <p>No Testimonials  available.</p>
                        )}


                    </>
                );

            case `Placement`:

                return courseCategory ? (

                    <div>
                        <p>{courseCategory?.placements_tab_description}</p>
                        <img
                            src={courseCategory.placements_tab_graph}

                            style={{ width: '300px', height: '200px', borderRadius: '50%' }}
                        />


                    </div>
                ) : (
                    <p>No data available.</p>
                );





            default:
                return null;
        }
    };

    return (
        <div className="adminmeta-div">
            <div className="college-info-container">



                <div className="banner-section flex">
                    <div style={{ backgroundColor: 'black', height: '23px', width: '23px' }}>
                        <a href="/learner/university-list">
                            <img src={BackArrow} style={{ filter: 'brightness(0) invert(1)', padding: '3px' }} />
                        </a>
                    </div>
                    <img className="college-banner" src={university?.logo} alt="College banner" />

                    <img className="college-logo" src={university?.logo} alt="College logo" />
                </div>
                <center>  <h2 style={{ paddingTop: '10px', color: '#333', fontSize: '1.9rem', textAlign: 'left', marginLeft: '24px', backgroundColor: '#f9f9f9', paddingLeft: '2px' }}>{university?.name}</h2></center>

                <nav className="mb-2 border-b " style={{ marginLeft: '23px' }}>

                    {['Overview', 'Courses', `Why ${university?.name}`, 'Admission', 'Placement', 'Faculty', 'Testimonials', 'Blogs'].map((content) => (
                        <button
                            key={content}
                            onClick={() => setSelectedContent(content)}
                            className='metabuttons'
                            style={{
                                display: 'inline-block',
                                padding: '0.5rem 0.2rem',
                                marginRight: '1rem',
                                textDecoration: 'none',
                                borderBottom: selectedContent === content ? '2px solid #ffffff' : 'none',
                                color: selectedContent === content ? '#ffffff' : '#6b7280',
                                cursor: 'pointer',
                                textDecoration: selectedContent === content ? 'underline' : 'none',
                                fontWeight: selectedContent === content ? 'bold' : 'normal',
                                transition: 'color 0.2s ease, border-color 0.2s ease',
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#ffffff'}
                            onMouseLeave={(e) => e.target.style.color = selectedContent === content ? '#ffffff' : '#000000'}
                        >
                            {content}
                        </button>
                    ))}
                </nav>






                <div className="college-details">
                    <div className="px-4 md:px-6 text-muted-foreground pt-20 mb5 text-left">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
                            <div className="md:col-span-2 space-y-6 text-left ">
                                {selectedProgram ? (
                                    <ProgramDetails


                                        university={university}
                                        program={selectedProgram}
                                        onBack={() => setSelectedProgram(null)} />
                                ) : (
                                    renderContent()
                                )}

                            </div>
                        </div>
                    </div>
                </div>


            </div>

            {
                university.programs.length > 5 && (
                    <center>
                        {selectedContent == 'Courses' ? <button onClick={toggleShowAll} className="view-all-btn" >
                            {showAll ? 'Show Less' : 'View All Courses'}
                        </button> : ''}
                    </center>
                )
            }
        </div >
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    const { getCollegeDetails, wpUniversityPosts, wpUniversityCategory, wpCourseCategory, wpTestimonialsCategory } = actions;
    return {
        getCollegeDetails: (center_id) => dispatch(getCollegeDetails(center_id)),
        wpTestimonialsCategory: (category_id) => dispatch(wpTestimonialsCategory(category_id)),


        wpUniversityPosts: (category_id) => dispatch(wpUniversityPosts(category_id)),
        wpCourseCategory: (category_id) => dispatch(wpCourseCategory(category_id)),
        wpUniversityCategory: () => dispatch(wpUniversityCategory()),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollegeMetaInfoList);